// extracted by mini-css-extract-plugin
export var teamContainer = "Team-module--teamContainer--2htkb";
export var removeTeamButton = "Team-module--removeTeamButton--VcLfD";
export var teamNameInput = "Team-module--teamNameInput--1wlKe";